import { render, staticRenderFns } from "./FormulaBag.vue?vue&type=template&id=588a78f5&scoped=true"
import script from "./FormulaBag.vue?vue&type=script&lang=js"
export * from "./FormulaBag.vue?vue&type=script&lang=js"
import style0 from "./FormulaBag.vue?vue&type=style&index=0&id=588a78f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588a78f5",
  null
  
)

export default component.exports